import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import featherShareImg from '../../../assets/images/Icon-feather-share.png';
import trachIconImg from '../../../assets/images/Icon-feather-trash-2.png';
import PlusIMgDark from '../../../assets/images/plusDark.png';
import downloadDark from '../../../assets/images/downloadDark.png';
import noRecord from '../../../assets/images/cloud-cross.png';
import { delWebhookSettings } from '../../../redux/actions/webhookSettings';
import { sendWebhookTestData } from '../../../services/extraServices';

const WebhookList = ({ webhooks, setModalOpen, sampleCSVdownload }) => {
  const dispatch = useDispatch();
  const deleteWebhook = (e, id) => {
    e.preventDefault();
    dispatch(delWebhookSettings(id));
  };
  return (
    <div id='tab-1' className='tab-content  webhookTabs'>
      <div className='webhookTabContent fullHeight'>
        <div className='tabTableBody'>
        {webhooks && webhooks.length > 0 && (
          <div className='eachTableRow heading'>
            <div className='tableCells'>Key/Title</div>
            <div className='tableCells'>URL</div>
            <div className='tableCells'>Send Test Data</div>
            <div className='tableCells'>Delete</div>
          </div>
        )}
          {webhooks && webhooks.length
            ? webhooks.map((w, k) => {
                return (
                  <div className='eachTableRow' key={k}>
                    <div className='tableCells'>{w.title}</div>
                    <div className='tableCells underlineText'>{w.url}</div>
                    <div className='tableCells actionImgs ttt'>
                      <Link
                        to='/#'
                        onClick={(e) => {
                          e.preventDefault();
                          sendWebhookTestData(w.title, w.url);
                        }}
                      >
                        <img
                          src={featherShareImg}
                          className='actionBtnImgs'
                          alt=''
                        />
                      </Link>
                    </div>
                    <div className='tableCells actionImgs'>
                      <Link to='/#' onClick={(e) => deleteWebhook(e, w._id)}>
                        <img
                          src={trachIconImg}
                          className='actionBtnImgs'
                          alt=''
                        />
                      </Link>
                    </div>
                  </div>
                );
              })
            : ''}{' '}
        </div>
        {webhooks && webhooks.length < 1 && (
          // <div className='noRecordTables'>No Records Found</div>
          <ul className='individualRow noRecordsWraper tableContent'>
							<li className='noRecord messageWrater'>
                <p>No Records found</p>
                <span className="noImageWraper">
                  <img src={noRecord} alt="" />
                </span>
                <span className="noRecorsBtnWraper">
                <button style={{margin: "10px 0 0 0"}}
								className='firstBtn gmNewBtn tabBtns'
								onClick={() => setModalOpen(true)}
							>
								<img src={PlusIMgDark} className='tabBtnImgs' alt='' /> Add
								Webhook
							</button>
              <button className='secondBtn gmNewBtn tabBtns' onClick={sampleCSVdownload}>
								<img src={downloadDark} className='tabBtnImgs' alt='' />{' '}
								Download Sample CSV
							</button>
              </span>
              </li>
						</ul>
        )}
      </div>
    </div>
  );
};

export default WebhookList;
